import React, { Component } from 'react'
import { Row, Col, Container } from "reactstrap";
import cover from '../../assets/cover.jpg'
import SignIn from '../auth/SignIn';

class Landing extends Component {
    render() {
        return (
            <>
               <Container>
                   <Row className="justify-content-center align-items-center mt-5">
                       <Col md="6"><img src={cover} width="100%"/></Col>
                       <Col md="2"></Col>
                       <Col md="4"><SignIn /></Col>

                   </Row>
               </Container>
            </>
        )
    }
}

export default Landing